import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

// import {getForumsStats} from '../../../actions/forumsStats';
import {fetchForums} from "../../../creators/forums";

import ForumStats from "./components/ForumStats";
import {PageLoader} from "../../components/Loader";
import {fetchForumChildrens} from "../../../creators/forums.children";
import ForumCategories from "./components/ForumCategories";
import Helmet from "react-helmet";
import {config} from "../../../config";
import {canonical} from "../../../libs/helper";
import createLink from "../../../libs/createLink";
import Advertising from "../../components/Advertising/Advertising";
import TagModerationQualificationWarning
    from "../../components/TagModerationQualificationWarning/TagModerationQualificationWarning";
import {Can} from "../../../ability-context";


class Forums extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            toggleTopMods: false,
            toggleTopUsers: false,
        };

        this.props.fetchForums({
            "primary": true,
            sort: "order",
            isTotal : false
            // slug :"rencontres-coquines"
            // slug : "sexualite"
            //select: "-children"
        });

    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     return nextProps.forumsInitialized !== this.props.forumsInitialized;
    // }

    render() {
        return !this.props.forumsInitialized ? (
            <div id="forums">
                <div className="container">
                    <div className={"card"}>
                        <PageLoader/>
                    </div>
                </div>
            </div>
        ) : (
            <div id="forums">
                <Helmet>
                    <title>{config.preTitle}Forums{config.postTitle}</title>
                    <link rel="canonical" href={`${canonical(createLink("forum"), "", "forum")}`} />
                </Helmet>
                <Can action={"qualification"} subject="TagModeration">
                    <TagModerationQualificationWarning />
                </Can>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    {/*<div className="settings-options">*/}
                    {/*    <Button size={"small"}*/}
                    {/*            content={"Voir le nouveau contenu"}/>*/}
                    {/*    <Button size={"small"}*/}
                    {/*            icon={"check"}*/}
                    {/*            content={"Marquer la communauté comme lue"}/>*/}
                    {/*</div>*/}
                    {this.props.forumsLoading ? (
                        <PageLoader/>
                    ) : (
                        <Fragment>
                            {this.props.forums && this.props.forums.map((forum, indexForum) => (
                                <div key={forum._id} className={"forum-card"}>
                                    <div className={"card"}>
                                        <ForumCategories location={this.props.location} match={this.props.match}
                                                        forumType={"forums"}
                                                        forumName={forum.name}
                                                        forumSlug={forum.slug}
                                                        forumId={forum._id}
                                                         indexForum={indexForum}
                                        />
                                    </div>
                                </div>
                            ))}
                            <ForumStats />
                        </Fragment>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        forums: state.forums.data,
        forumsLoading: state.forums.loading,
        forumsInitialized: state.forums.initialized,
        // forumsStats: state.forumsStats.forumsStats,
        // forumsStatsLoading: state.forumsStats.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForums,
    fetchForumChildrens,
    // getForumsStats
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Forums);
